import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "form__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PresentationMultiPageForm = _resolveComponent("PresentationMultiPageForm")!
  const _component_PresentationOnePageForm = _resolveComponent("PresentationOnePageForm")!
  const _component_SwitchTab = _resolveComponent("SwitchTab")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createBlock(_component_ModalComponent, {
    title: "Скачать презентацию",
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isOpen) = $event)),
    onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOpen = false))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createBlock(_component_SwitchTab, {
          key: _ctx.formKey,
          textTrue: "Многостраничная",
          textFalse: "Одностраничная",
          mode: "line",
          disabled: _ctx.isLoading
        }, {
          "first-tab": _withCtx(() => [
            _createVNode(_component_PresentationMultiPageForm, {
              countries: _ctx.countries,
              defaultCountryId: _ctx.defaultCountryId,
              disabled: _ctx.isLoading,
              onLoading: _ctx.onFormLoading,
              onSuccess: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = false))
            }, null, 8, ["countries", "defaultCountryId", "disabled", "onLoading"])
          ]),
          "second-tab": _withCtx(() => [
            _createVNode(_component_PresentationOnePageForm, {
              countries: _ctx.countries,
              defaultCountryId: _ctx.defaultCountryId,
              disabled: _ctx.isLoading,
              onLoading: _ctx.onFormLoading,
              onSuccess: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpen = false))
            }, null, 8, ["countries", "defaultCountryId", "disabled", "onLoading"])
          ]),
          _: 1
        }, 8, ["disabled"]))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}